"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deletePartnerCustomFilter = void 0;
const routes_1 = require("../../routes");
const deletePartnerCustomFilter = (client) => async (partnerId, cropId, categoryId) => {
    const queryParams = new URLSearchParams();
    queryParams.append('crop_id', cropId);
    queryParams.append('category_id', categoryId);
    const url = `${routes_1.ENDPOINTS.DELETE_PARTNER_CUSTOM_FILTER.applyParams(partnerId)}?${queryParams.toString()}`;
    const { data } = await client.delete(url);
    return data;
};
exports.deletePartnerCustomFilter = deletePartnerCustomFilter;
